import * as React from "react";
import { SVGProps } from "react";

const Ubiq = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1785 2000" {...props}>
    <path fill="#333" d="m1089.3 213 25.24 804.73L1785 594.08z" />
    <path fill="#494949" d="M1780.27 1436.69V590.93L819.54 1200v800h32.34" />
    <path fill="#0ca579" d="m695.7 1787-25.24-804.75L0 1405.92z" />
    <path fill="#00ea90" d="M4.73 563.31v845.76l960.73-608.28V0h-32.34" />
  </svg>
);

export default Ubiq;
